import { render } from "./MemberBookingMerchantCard.vue?vue&type=template&id=6bba9db0&scoped=true"
import script from "./MemberBookingMerchantCard.vue?vue&type=script&lang=js"
export * from "./MemberBookingMerchantCard.vue?vue&type=script&lang=js"

import "./MemberBookingMerchantCard.vue?vue&type=style&index=0&id=6bba9db0&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bba9db0"]])

export default __exports__